import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%",
    "display": "inline-flex"
  }
};
const _hoisted_2 = {
  class: "right-div"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("注销");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_sub_menu = _resolveComponent("el-sub-menu");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
    "default-active": _ctx.$route.path,
    class: "el-menu-demo left-div",
    mode: "horizontal",
    "background-color": "#545c64",
    "text-color": "#fff",
    "active-text-color": "#ffd04b",
    onSelect: $options.handleSelect,
    router: "",
    ellipsis: false,
    ref: "menu"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menus, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: index
      }, [item.entity.type == 2 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: item.entity.url
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
        _: 2
      }, 1032, ["index"])) : _createCommentVNode("", true), item.entity.type == 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 1,
        index: index + ''
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item2, index2) => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            index: item2.entity.url,
            key: index2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item2.label), 1)]),
            _: 2
          }, 1032, ["index"]);
        }), 128))]),
        _: 2
      }, 1032, ["index"])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  }, 8, ["default-active", "onSelect"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    type: "text",
    onClick: _cache[0] || (_cache[0] = $event => $options.logout())
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  })])]);
}